module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Black-Adv_Web.1a18a406.woff2";